import cloudenv from '@Cloudenv/router'

cloudenv.meta.bottomLine = true

export default cloudenv
